// ForgotPasswordForm.tsx
import React, { useState } from "react";
import { Box, TextField, Button, Typography, FormControl, Link } from "@mui/material";
import { useTranslation } from 'react-i18next';
import { useAuthStore } from "../../store/useAuthStore3";

interface ForgotPasswordFormProps {
  initialEmail?: string;
}

const ForgotPasswordForm: React.FC<ForgotPasswordFormProps> = ({ initialEmail = "" }) => {
  const { t } = useTranslation();
  const [email, setEmail] = useState(initialEmail);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    setIsLoading(true);
    setError(null);

    try {
      await useAuthStore.getState().sendResetPasswordEmail(email);
      useAuthStore.setState({ authState: 'FORGOT_PASSWORD_SUCCESS' });
    } catch (err: any) {
      setError(err?.message || t('ForgotPassword.DefaultError', 'Произошла ошибка'));
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Box
      component="form"
      onSubmit={handleSubmit}
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: 2,
        maxWidth: 400,
        mx: "auto",
        p: 3,
        border: "1px solid #ccc",
        borderRadius: "8px",
      }}
    >
      <Typography variant="h4" component="h1" align="center">
        {t('ForgotPassword.Title', 'Восстановление')}
      </Typography>

      <Typography variant="body2" color="text.secondary" align="center">
        {t('ForgotPassword.Instructions', 'Введите ваш Email, и мы отправим ссылку для сброса пароля.')}
      </Typography>
      
      {error && (
        <Typography color="error" align="center" sx={{ fontWeight: "bold" }}>
          {error}
        </Typography>
      )}      
      
      <FormControl fullWidth>
        <TextField
          label={t('LoginForm.Email')}
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          disabled={isLoading}
          required
        />
      </FormControl>

      <Button 
        type="submit" 
        variant="contained" 
        disabled={isLoading}
      >
        {isLoading ? t('LoginForm.Loading') : t('ForgotPassword.Submit', 'Сбросить пароль')}
      </Button>

      <Box sx={{ display: 'flex', justifyContent: 'center', mt: 1 }}>
        <Link
          component="button"
          type="button"
          variant="body2"
          onClick={() => useAuthStore.setState({ authState: 'LOGIN' })}
          disabled={isLoading}
          underline="hover"
        >
          {t('ForgotPassword.BackToLogin', 'Назад к входу')}
        </Link>
      </Box>
    </Box>
  );
};

export default ForgotPasswordForm;